import { ModuleFE_PermissionProject } from './ModuleFE_PermissionProject.js';
export const ModulePackFE_PermissionProject = [ModuleFE_PermissionProject];
//# sourceMappingURL=module-pack.js.map